export default __webpack_public_path__ + "static/media/live-icon.a0d0486d.webp";